export const SVG_SPRITE_DEFAULT_PROVIDER_ID = "plxDefaultIcons";
//# sourceMappingURL=SvgSprite.helpers.js.map